import React from 'react';
import embedSrc from 'images/embed_el.svg';
import EmbedForm from '../EmbedForm';

const OtherEmbed = ({ onSubmit, onUrlInput }) => (
  <div className="EditorElement-uploadArea">
    <img
      className="EditorElement-icon"
      src={embedSrc}
      alt={t('lessons.editor.elements.embed')}
    />
    <EmbedForm onSubmit={onSubmit} onUrlInput={onUrlInput} />
    <p>
      Works with links from Google Docs, Prezi, Soundcloud, and{' '}
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="http://embed.ly/providers"
      >
        more
      </a>
    </p>
  </div>
);

export default OtherEmbed;
